document.addEventListener("DOMContentLoaded", function () {
  const html = document.documentElement;
  const formBlock = document.querySelector(".st-quote-form-sc .st-quote-form-block");

  function openForm() {
    formBlock.classList.add("active");
    html.classList.add("overflow-hidden");
  }

  function closeForm() {
    formBlock.classList.remove("active");
    html.classList.remove("overflow-hidden");
  }

  // Open on quote button
  document.querySelectorAll(".quote-btn").forEach(btn => {
    btn.addEventListener("click", e => {
      e.preventDefault();
      openForm();
    });
  });

  // Close on close button
  document.querySelectorAll(".qoute-close-btn").forEach(btn => {
    btn.addEventListener("click", e => {
      e.preventDefault();
      closeForm();
    });
  });

  // Close on outside click
  document.addEventListener("click", e => {
    if (
      formBlock.classList.contains("active") &&
      !formBlock.contains(e.target) &&
      !e.target.closest(".quote-btn")
    ) {
      closeForm();
    }
  });

  // Close on Escape key
  document.addEventListener("keydown", e => {
    if (e.key === "Escape") {
      closeForm();
    }
  });
});

// Shipping note js
document.addEventListener('click', function(event) {
  const toggleButton = event.target.closest('.st-cart-shipping-note-mobile-block');
  const clickedInsideNote = event.target.closest('.st-cart-shipping-note-mobile-text-block');
  const closeArrow = event.target.closest('.st-cart-shipping-note-mobile-close-arrow');

  // 1. If the user clicked the main toggle button, open/close the note
  if (toggleButton) {
    const textBlock = toggleButton.nextElementSibling;
    
    if (textBlock && textBlock.classList.contains('st-cart-shipping-note-mobile-text-block')) {
      textBlock.classList.toggle('active');
      toggleButton.classList.toggle('is-open'); 
    }
    return; // Stop here
  }

  // 2. If the user clicked inside the note, BUT they didn't click the close arrow, do nothing
  if (clickedInsideNote && !closeArrow) {
    return;
  }

  // 3. If the user clicked outside the note, OR they clicked the close arrow, close it!
  const activeNotes = document.querySelectorAll('.st-cart-shipping-note-mobile-text-block.active');
  
  activeNotes.forEach(function(note) {
    note.classList.remove('active');
    
    // Reset the open state on the main button too
    const relatedButton = note.previousElementSibling;
    if (relatedButton && relatedButton.classList.contains('st-cart-shipping-note-mobile-block')) {
      relatedButton.classList.remove('is-open');
    }
  });
});